<template>
  <v-card outlined>
    <v-card-text class="text-left" style="max-height: 430px; overflow-y: auto">
      <h3 class="text-center">LINE CONNECT</h3>
      <ul>
        <li>
          ข้อกำหนดและเงื่อนไขการใช้บริการนี้ มีผลบังคับระหว่าง บริษัท
          เจนเนอราลี่ ประกันชีวิต (ไทยแลนด์) จำกัด (มหาชน) และ บริษัท
          เจนเนอราลี่ ประกันภัย (ไทยแลนด์) จำกัด (มหาชน) (ซึ่งต่อไปนี้จะเรียกว่า
          “บริษัทฯ”) กับผู้ใช้งาน บน Application LINE ซึ่งต่อไปนี้จะเรียกว่า
          “ผู้ใช้บริการ”
          โดยผู้ใช้บริการตกลงใช้บริการและปฏิบัติตามข้อกำหนดและเงื่อนไขการใช้บริการต่อไปนี้โดยปราศจากข้อยกเว้นใดๆทั้งสิ้น
        </li>
        <li>
          การบริการข้อมูลบนLINE CONNECT นี้
          โปรดศึกษาข้อตกลงและเงื่อนไขการเข้าใช้งานอย่างระมัดระวัง
          เนื่องจากข้อตกลงและเงื่อนไขนี้ระบุถึงสิทธิต่างๆของท่าน
          รวมถึงข้อจำกัดและข้อยกเว้นต่างๆ
          ซึ่งมีผลใช้ในกิจกรรมทั้งหมดบนเว็บไซต์ที่ผู้ใช้งานควรจะรับทราบก่อนที่จะลงทะเบียนเข้าใช้ระบบนี้
        </li>
        <li>
          การที่ท่านสมัครใช้บริการ และ/หรือ ใช้บริการไม่ว่าในลักษณะใดๆ หรือ
          โดยการเลือก “ตกลง” เพื่อยอมรับตามข้อตกลงและเงื่อนไขนี้
          ถือว่าท่านได้รับทราบและรับรู้เนื้อหาของข้อตกลงและเงื่อนไขนี้โดยครบถ้วนสมบูรณ์แล้ว
          รวมถึงกฎระเบียบนโยบายต่างๆของบริษัทฯ โดยทางบริษัทฯ
          สามารถเปลี่ยนแปลงเงื่อนไขได้โดยไม่จำเป็นต้องแจ้งให้ทราบล่วงหน้า
        </li>
      </ul>

      <h3 class="text-center mt-4">การลงทะเบียนและการยกเลิกบัญชีผู้ใช้</h3>
      <ul>
        <li>
          การลงทะเบียนเป็นผู้ใช้งานLINE CONNECT จะต้องไม่เป็นบุคคลที่ทางบริษัทฯ
          เคยห้าม หรือระงับมิให้ใช้งานมาก่อน
        </li>
        <li>
          ผู้ใช้งานจะต้องใช้ LINE CONNECT หรือกิจกรรมต่างๆ ที่อยู่บน LINE
          CONNECT เพื่อประโยชน์ส่วนตัวเท่านั้น
          และจะต้องไม่ใช้เพื่อประโยชน์ทางธุรกิจ ไม่ว่าลักษณะใดๆ
        </li>
        <li>
          ในการลงทะเบียนเป็นผู้ใช้งานนั้น ผู้ใช้งานจะต้องแจ้งชื่อ
          หรือข้อมูลส่วนตัวอื่นๆ ทั้งนี้ โปรดดูรายละเอียดเพิ่มเติมในหัวข้อ
          นโยบายความเป็นส่วนตัว
        </li>
        <li>
          ในขั้นตอนการลงทะเบียน ผู้ใช้งานจะได้รับรหัสผ่าน (password)
          สำหรับผ่านเข้าใช้บัญชีของผู้ใช้งานทางข้อควม SMS
          ผ่านทางโทรศัพท์มือถือของผู้ใช้งาน
          โดยผู้ใช้งานจะต้องเก็บรักษารหัสผ่านเป็นความลับ
        </li>
        <li>
          ผู้ขอใช้บริการสามารถเปลี่ยนแปลง Login Name หรือ Usernameและ/หรือ
          รหัสผ่าน (Password) และ/หรือ PIN - Person Identification Number
          และ/หรือ รหัสที่เกี่ยวข้องกับการเข้าใช้บริการLINE CONNECT
          เมื่อใดก็ได้โดยดำเนินการตามวิธีการและเงื่อนไขที่บริษัทฯ กำหนด
        </li>
        <li>
          บริษัทฯขอสงวนสิทธิที่จะปฏิเสธการลงทะเบียนหรือยกเลิกบัญชีเมื่อใดก็ได้
        </li>
        <li>
          ในการลงทะเบียนผู้ใช้งาน ผู้ใช้งานตกลงโดยชัดแจ้งให้บริษัทฯ เก็บ
          และใช้ข้อมูลของผู้ใช้งานเพื่อวัตถุประสงค์เกี่ยวกับการนำเสนอผลิตภัณฑ์ประกันภัย/ประกันชีวิต
          แจ้งข้อมูลข่าวสารจากบริษัท การติดต่อสื่อสาร หรือสถิติ
        </li>
        <li>
          บริษัทฯขอสงวนสิทธิที่จะยกเลิกบัญชีของผู้ใช้งานได้โดยไม่ต้องแจ้งให้ทราบล่วงหน้า
        </li>
        <li>
          ผู้ใช้งานมีสิทธิในการเข้าถึงข้อมูลและใช้งานที่แตกต่างกันตามสถานะของผู้ใช้งานตามวิธีการและเงื่อนไขที่บริษัทฯกำหนด
        </li>
        <li>
          หากผู้ใช้งานมีปัญหาเกี่ยวกับรหัสผ่าน ผู้ใช้งานสามารถติดต่อได้ที่ Line@
          ID:
          <a
            href="https://line.me/ti/p/@generalithailand"
            target="_blank"
            rel="noopener noreferrer"
            >Generali Thailand</a
          >
          ในวันและเวลาทำการ (จ. – ศ. เวลา 8.30 – 20.00 น.)
        </li>
        <li>
          ผู้ใช้งานตกลงและรับทราบว่าหากเกิดกรณีผู้ใช้งานถูกระงับใช้ถาวรหรือชั่วคราวโดยระบบของบริษัทฯ
          ผู้ใช้งานยินยอมที่จะไม่เรียกร้องค่าเสียหายใดๆที่อาจเกิดขึ้นจากการระงับดังกล่าวกับบริษัทฯทั้งสิ้น
        </li>
        <li>
          การดูแลรักษาข้อมูลส่วนบุคคล
          บริษัทฯตระหนักและให้ความสำคัญสูงสุดถึงความปลอดภัยในข้อมูลของผู้ใช้งาน
          และพร้อมยึดถือที่จะปฏิบัติตามภายใต้กรอบข้อบังคับของกฎหมายด้านการดูแลรักษาข้อมูล
          ทั้งนี้ผู้ใช้งานมีสิทธิในการเลือกที่จะให้ข้อมูลส่วนบุคคลตามที่บริษัทฯร้องขอหรือปฏิเสธ
          อย่างไรก็ตามการปฏิเสธไม่ให้ข้อมูลดังกล่าว
          อาจมีผลต่อข้อจำกัดในการใช้บริการต่างๆของบริษัทฯเช่นกัน
        </li>
        <li>
          เอกสารหรือหนังสือใดๆ ที่บริษัทฯ ส่งไปยังผู้ใช้งานตามที่อยู่
          และ/หรือสำนักงาน และ/หรือ E-mail Address
          ตามที่ผู้ใช้งานแจ้งไว้ในใบคำขอเอาประกันภัย
          หรือใบคำขอเปลี่ยนแปลงข้อมูลการใช้บริการ (ถ้ามี) หรือ LINE CONNECT
          นี้แล้ว ให้ถือว่าได้ส่งโดยชอบและผู้ใช้งานได้ทราบข้อความในเอกสาร
          หนังสือ หรือข้อมูลนั้นๆ แล้ว
        </li>
      </ul>

      <h3 class="text-center mt-4">สิ่งที่ไม่อยู่ในความรับผิดชอบ</h3>
      <ul>
        <li>
          ภายใต้ข้อกำหนดของกฎหมายได้อนุญาตให้การดำเนินการเป็นไปอย่างเต็มที่
          โดยที่เนื้อหาบน LINE CONNECT จัดขึ้นเพื่อวัตถุประสงค์การทำการตลาด
          โฆษณาและการประชาสัมพันธ์ผลิตภัณฑ์ประกันภัย/ชีวิตของบริษัท
          และอำนวยความสะดวกในการให้บริการที่เกี่ยวข้องกับกรมธรรม์แก่ลูกค้าของบริษัท
          ซึ่งถือเป็นสิทธิของบริษัทฯ
          แต่บริษัทจะไม่รับผิดชอบในการแทรกแซงหรือความผิดพลาดต่างๆ
          ที่เกิดขึ้นจากการใช้ LINE CONNECT นี้ รวมถึงเรื่องไวรัสและปัจจัยอื่นๆ
          และจะไม่รับรองในเรื่องของความถูกต้องแม่นยำ
          ซึ่งท่านได้มาจากเนื้อหาของเว็บไซต์
        </li>
        <li>
          บริษัทฯ จะไม่รับผิดต่อความเสียหายใด ๆ รวมถึง ความเสียหาย
          สูญเสียและค่าใช้จ่ายที่เกิดขึ้นไม่ว่าโดยตรงหรือโดยอ้อม
          ที่เป็นผลหรือสืบเนื่องจากการที่ผู้ใช้บริการหรือเว็บไซต์ที่เชื่อมโยงกับ
          LINE CONNECT นี้ หรือต่อความเสียหาย
          สูญเสียหรือค่าใช้จ่ายที่เกิดจากความล้มเหลวในการใช้งาน ความผิดพลาด
          การละเว้น การหยุดชะงัก ข้อบกพร่อง ความไม่สมบูรณ์ คอมพิวเตอร์ไวรัส
          ถึงแม้ว่าบริษัทฯ จะได้รับแจ้งว่าอาจจะเกิดความเสียหาย
          สูญเสียหรือค่าใช้จ่ายดังกล่าวขึ้นนอกจากนี้
          บริษัทฯไม่รับผิดต่อผู้ใช้บริการหรือบุคคลจากการเรียกร้องใด ๆ
          ที่เกิดขึ้นจากบน LINE CONNECT หรือเนื้อหาใด ๆ
          ซึ่งรวมถึงการตัดสินใจหรือการกระทำใด ๆ
          ที่เกิดจากความเชื่อถือในเนื้อหาดังกล่าวของผู้ใช้งาน
          หรือในความเสียหายใด ๆ ไม่ว่าความเสียหายทางตรง หรือทางอ้อม
          รวมถึงความเสียหายอื่นใดที่อาจเกิดขึ้นได้ผู้ใช้บริการยอมรับและตระหนักดีว่า
          บริษัทฯ จะไม่ต้องรับผิดชอบต่อการกระทำใดของผู้ใช้บริการทั้งสิ้น
        </li>
      </ul>

      <h3 class="text-center mt-4">ความเป็นเจ้าของข้อมูล</h3>
      <ul>
        <li>
          ข้อมูลใดๆที่นอกเหนือจากข้อมูลส่วนตัวที่ส่งเข้ามาทาง LINE CONNECT นี้
          หรือสื่ออื่นๆก็ดี รวมทั้งข้อมูล ความคิดเห็น คำถามหรือคำแนะนำใดๆก็ตาม
          จะถือเป็นสิทธิของบริษัทฯ ข้อมูลที่กล่าวมานี้นอกจากข้อมูลส่วนตัวแล้ว
          อาจจะถูกนำไปใช้ในจุดประสงค์ต่างๆได้ บริษัทฯสามารถใช้ความคิด หลักการ
          ข้อควรรู้ หรือเทคนิคต่างๆที่ทางท่านส่งเข้ามาผ่านทาง LINE CONNECT
          นี้สำหรับจุดประสงค์ต่างๆ เพื่อใช้ในการปรับปรุงและพัฒนาผลิตภัณฑ์
          หรือการให้บริการอย่างต่อเนื่อง การวิเคราะห์ข้อมูลลูกค้าหรือผู้ใช้งาน
          และสนองตอบความพึงพอใจของผู้ใช้งาน
        </li>
        <li>
          บริษัทฯ เป็นเจ้าของลิขสิทธิ์ หรือสิทธิในทรัพย์สินทางปัญญาในเนื้อหาต่าง
          ๆ ที่แสดงบน LINE CONNECT นี้ ซึ่งครอบคลุมถึงข้อความ บทความ รูปภาพ
          ตัวอักษร วิดีทัศน์ เสียง กราฟฟิค ดนตรีหรือเสียงอื่นใด
          หรือโปรแกรมคอมพิวเตอร์ (รวมเรียกว่า “เนื้อหา”)
          เว้นแต่จะระบุไว้เป็นอย่างอื่นโดยชัดแจ้ง โดยบริษัทฯ
          มีสิทธิหรือมีอำนาจควบคุมการใช้เนื้อหานั้นห้ามมิให้ทำซ้ำ ดัดแปลง
          จัดเก็บ ถ่ายโอน ขาย ให้เช่า ลอกเลียนแบบ เผยแพร่ต่อสาธารณชน
          หรือกระทำการใดๆ
          อันเป็นการละเมิดลิขสิทธิ์หรือสิทธิในทรัพย์สินทางปัญญาโดยไม่ได้รับความยินยอมล่วงหน้าเป็นลายลักษณ์อักษรจากบริษัทฯ
          เว้นแต่การใช้ จัดพิมพ์ หรือดาวน์โหลดเนื้อหาที่แสดงบน LINE CONNECT
          เพื่อใช้เป็นการส่วนบุคคล
          โดยผู้ใช้ต้องไม่ลบข้อความเกี่ยวกับลิขสิทธิ์หรือสิทธิในทรัพย์สินทางปัญญาออกจากเนื้อหานั้น
          เว้นแต่ผู้ใช้จะได้รับอนุญาตจากบริษัทเป็นลายลักษณ์อักษรอย่างชัดเจน
        </li>
      </ul>

      <h3 class="text-center mt-4">การจำกัดการใช้ข้อมูล</h3>
      <ul>
        <li>
          LINE CONNECT นี้เป็นสิทธิภายใต้การดำเนินการโดยบริษัทฯ
          เว้นแต่จะได้รับอนุญาตจากบริษัทฯ จึงห้ามไม่ให้ทำซ้ำหรือนำไปแก้ไข
          เผยแพร่ใหม่ หรือใส่และส่งข้อมูลในทางใดก็ตาม โดยสามารถนำข้อมูลจากใน
          LINE มาใช้ได้อย่างเดียว ไม่สามารถที่จะจัดส่ง แก้ไข ส่งต่อ นำมาใช้ใหม่
          นำมาโพสต์ใหม่หรือใช้บางส่วนของ LINE นี้ในทางสาธารณะหรือในทางการค้า
          รวมถึงข้อความ รูปภาพ เสียงและวีดีโอ โดยปราศจากการอนุญาตจากบริษัทฯ
          เป็นลายลักษณ์อักษร บริษัทฯจะไม่รับผิดชอบหากท่านใช้ข้อมูลที่แสดงในLINE
          นี้ไปละเมิดสิทธิของบุคคลภายนอก
        </li>
      </ul>

      <h3 class="text-center mt-4">นโยบายความเป็นส่วนตัว</h3>
      <ul>
        <li>
          บริษัทฯ เคารพสิทธิในความเป็นส่วนตัวของข้อมูลของผู้ใช้งาน
          และเข้าใจดีว่าผู้ใช้งานมีความประสงค์ที่จะได้รับความปลอดภัยสูงสุดในการทำธุรกรรมผ่านLINE
          ดังนั้น ข้อมูลต่างๆของผู้ใช้งานที่บริษัทฯได้รับมานั้น
          โดยหลักการแล้วจะถูกนำไปใช้ให้เป็นตามวัตถุประสงค์ของผู้ใช้งานเท่านั้น
          บริษัทฯจะดำเนินมาตรการที่เข้มงวดในการรักษาความปลอดภัย
          ตลอดจนจะป้องกันมิให้มีการนำข้อมูลไปใช้โดยมิได้รับอนุญาตจากผู้ใช้งานก่อน
        </li>
        <li>
          นโยบายความเป็นส่วนตัวที่ปรากฎด้านล่างนี้
          ใช้บังคับกับบัญชีของผู้ใช้งานและข้อมูลต่างๆที่ผู้ใช้งานได้ให้ไว้กับ
          LINEนี้
        </li>
      </ul>

      <h3 class="text-center mt-4">เครื่องหมายการค้าและลิขสิทธิ์</h3>
      <ul>
        <li>
          เครื่องหมายการค้า เครื่องหมายการบริการ ชื่อทางด้านการค้า โลโก้
          และไอคอนทั้งหมด เป็นทรัพย์สินของบริษัทฯ ไม่มีสิ่งใดใน
          LINEนี้ที่สามารถนำไปใช้ได้โดยไม่ขออนุญาตเป็นลายลักษณ์อักษรจากบริษัทฯ
          ห้ามนำสัญลักษณ์ต่างๆในLINEนี้ไปใช้โดยไม่ได้รับอนุญาต
          หากมีผู้ใดที่ละเมิดในการใช้เครื่องหมายการค้า
          หรือลิขสิทธิ์ของบริษัทอาจนำมาซึ่งการละเมิดกฎหมายลิขสิทธิ์และอาจมีโทษทางกฎหมายได้
        </li>
      </ul>

      <h3 class="text-center mt-4">สิทธิในการเข้าถึง</h3>
      <ul>
        <li>
          บริษัทฯ สงวนสิทธิในการปรับปรุงหรือแก้ไข LINE หรือเนื้อหาบนLINEนี้
          ในเวลาใด ๆ
          รวมทั้งขอสงวนสิทธิที่จะปฏิเสธหรือจำกัดการเข้าถึงLINEนี้ของบุคคลใด
          โดยไม่จำเป็นต้องบอกกล่าวหรือระบุเหตุผลในการดำเนินการนั้น
        </li>
      </ul>

      <h3 class="text-center mt-4">ข้อยกเว้นความรับผิด</h3>
      <ul>
        <li>
          บริษัทฯ จะไม่รับผิดต่อความเสียหายใด ๆ รวมถึง ความเสียหาย
          สูญเสียและค่าใช้จ่ายที่เกิดขึ้นไม่ว่าโดยตรงหรือโดยอ้อม
          ที่เป็นผลหรือสืบเนื่องจากการที่ผู้ใช้งานเชื่อมโยงกับ LINEนี้
          หรือต่อความเสียหาย
          สูญเสียหรือค่าใช้จ่ายที่เกิดจากความล้มเหลวในการใช้งาน ความผิดพลาด
          การละเว้น การหยุดชะงัก ข้อบกพร่อง ความไม่สมบูรณ์ คอมพิวเตอร์ไวรัส
          ถึงแม้ว่า บริษัทฯ จะได้รับแจ้งว่าอาจจะเกิดความเสียหาย
          สูญเสียหรือค่าใช้จ่ายดังกล่าวขึ้นนอกจากนี้ บริษัทฯ
          ไม่รับผิดต่อผู้ใช้งานหรือบุคคลจากการเรียกร้องใด ๆ ที่เกิดขึ้นจากบนLINE
          หรือเนื้อหาใด ๆ ซึ่งรวมถึงการตัดสินใจหรือการกระทำใด ๆ
          ที่เกิดจากความเชื่อถือในเนื้อหาดังกล่าวของผู้ใช้บริการ
          หรือในความเสียหายใด ๆ ไม่ว่าความเสียหายทางตรง หรือทางอ้อม
          รวมถึงความเสียหายอื่นใดที่อาจเกิดขึ้นได้ผู้ใช้บริการยอมรับและตระหนักดีว่า
          บริษัทฯ จะไม่ต้องรับผิดชอบต่อการกระทำใดของผู้ใช้บริการทั้งสิ้น
        </li>
        <li>
          ผู้ใช้บริการยอมรับว่าบริการบางประเภท บริษัทฯ
          ได้นำข้อความหรือข้อมูลมาจากบุคคลภายนอก หรือบริษัทฯ
          ได้เชื่อมต่อระบบของบริษัทฯ ไปยังข้อมูลของบุคคลภายนอก บริษัทฯ
          จึงไม่สามารถรับรองความถูกต้องสมบูรณ์ของข้อความหรือข้อมูลดังกล่าวได้รวมถึงบริษัทฯ
          ไม่มีส่วนเกี่ยวข้องและไม่ได้ให้การรับรองหรือรับประกันใดๆ
          เกี่ยวกับสินค้า บริการ ข้อเสนอ รายการส่งเสริมการขาย และ/หรือ
          สิทธิประโยชน์ใดๆ ที่ผลิต และ/หรือให้บริการ โดยบุคคลภายนอก ทั้งนี้
          บริษัทฯ ไม่มีความรับผิดต่อผู้ใช้บริการหรือบุคคลใดๆ ในความเสียหายใดๆ
          จากการนำข้อความหรือข้อมูลดังกล่าวไปใช้และ/หรือเหตุอื่นใดอันเกิดขึ้นจากสินค้า
          และ/หรือ การให้บริการใดๆ ทั้งสิ้น
        </li>
      </ul>

      <h3 class="text-center mt-4">การชดใช้ค่าเสียหาย</h3>
      <ul>
        <li>
          กรณีที่เกิดความเสียหายแก่ บริษัทฯ อันเนื่องมาจากการดำเนินคดี
          การบังคับใช้สิทธิเรียกร้อง
          การชดใช้ค่าเสียหายจากความรับผิดหรือค่าใช้จ่ายใด ๆ (รวมถึงค่าทนายความ)
          ที่เกิดขึ้นสืบเนื่องจากการใช้เว็บไซต์ของผู้ใช้บริการ
          ผู้ใช้บริการรับจะชดใช้ความเสียหายดังกล่าวให้แก่ บริษัทฯ ทั้งสิ้น
          ไม่ว่ากรณีดังกล่าวจะเกิดจากการที่ผู้ใช้บริการไม่ปฏิบัติตามเงื่อนไขการให้บริการนี้หรือไม่
        </li>
      </ul>

      <h3 class="text-center mt-4">ข้อสงวนสิทธิในการดำเนินการเว็บไซต์</h3>
      <ul>
        <li>
          บริษัทฯ สงวนสิทธิในการเปลี่ยนแปลงหรือระงับการใช้ LINEนี้ไม่ว่าในเวลาใด
          ๆ โดยไม่จำต้องบอกกล่าวแก่ผู้ใช้บริการ
          และโดยปราศจากความรับผิดต่อผู้ใช้บริการหรือต่อบุคคลภายนอก
          กรณีมีความเปลี่ยนแปลงใด ๆ บนLINE CONNECT
          ย่อมถือว่าผู้ใช้บริการได้ยอมรับความเปลี่ยนแปลงดังกล่าวแล้ว และบริษัทฯ
          สามารถปฏิเสธสิทธิในการใช้LINEทั้งหมดหรือบางส่วนแก่ผู้ใดก็ได้
          โดยไม่ต้องแจ้งล่วงหน้า
        </li>
      </ul>

      <h3 class="text-center mt-4">กฎหมายที่ใช้บังคับ</h3>
      <ul>
        <li>
          การตีความ และการบังคับตามเงื่อนไขการให้บริการฉบับนี้
          ให้เป็นไปตามกฎหมายไทย
        </li>
      </ul>

      <p class="mt-4" style="text-indent: 40px">
        ผู้ใช้บริการตกลงและยอมรับว่าการกระทำใดๆ
        ผ่านระบบบริการอิเล็กทรอนิกส์ของบริษัทฯ
        ไม่ว่าจะเกี่ยวกับการใช้บริการอิเล็กทรอนิกส์ประเภทใดๆ ก็ตาม
        หากได้กระทำไปโดยการใช้รหัสประจำตัว และ/หรือ โดยการใช้บริการ Pre-login
        ตามข้อกำหนดและเงื่อนไขการใช้บริการนี้แล้ว
        ให้ถือว่าถูกต้องสมบูรณ์และผูกพันผู้ใช้บริการทุกประการ
        โดยผู้ใช้บริการไม่ต้องลงลายมือชื่อในเอกสารใดๆ ทั้งสิ้น
        และผู้ขอใช้บริการตกลงรับผิดชอบการกระทำดังกล่าวเสมือนหนึ่งว่าผู้ใช้บริการเป็นผู้กระทำด้วยตนเอง
        ทั้งนี้ ไม่ว่าจะเกิดขึ้นโดยผู้ใช้บริการหรือบุคคลใด
        และไม่ว่าจะด้วยเหตุใดๆ ก็ตาม
      </p>

      <h3 class="mt-4">
        นโยบายข้อมูลส่วนบุคคลสำหรับลูกค้าที่มีกรมธรรม์กับบริษัท
      </h3>

      <p class="mt-4" style="text-indent: 40px">
        กรณีที่ท่านเป็นลูกค้าที่มีกรมธรรม์กับบริษัท
        บริษัทได้ประกาศนโยบายคุ้มครองข้อมูลส่วนบุคคลของบริษัท ดังนั้น
        บริษัทขอแจ้งให้ท่านทราบว่าบริษัทมีการจัดเก็บ ใช้
        และเปิดเผยข้อมูลส่วนบุคคลของท่าน
        เพื่อการพิจารณารับประกันภัยและการให้บริการเกี่ยวกับกรมธรรม์
        ซึ่งเป็นไปตามข้อบังคับของ พรบ.คุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562
        ท่านสามารถศึกษานโยบายของบริษัทที่เกี่ยวข้องกับการคุ้มครองและการใช้ข้อมูลส่วนบุคคลได้ที่เวบไซต์ของบริษัท
        www.generali.co.th
      </p>

      <!-- <ol>
        <li>
          <div class="font-weight-bold">ข้อมูลที่จัดเก็บและใช้โดยบริษัท</div>
          <p class="mt-4" style="text-indent: 40px">
            ข้อมูลส่วนบุคคลของท่านที่บริษัทได้รับมา เช่น ชื่อ อายุ ที่อยู่ เพศ
            หมายเลขโทรศัพท์ หมายเลขบัตรประชาชน อีเมล ไลน์ไอดี ภาพถ่าย
            ตำแหน่งสถานที่อยู่ของท่าน เป็นต้น
            หรือข้อมูลซึ่งสามารถบ่งบอกตัวบุคคลของท่านได้
            และเป็นข้อมูลส่วนบุคคลที่มีความสมบูรณ์ ถูกต้อง เป็นปัจจุบัน
            และมีคุณภาพ
            จะถูกนำไปใช้ให้เป็นไปตามวัตถุประสงค์ที่กำหนดไว้ตามหนังสือนี้เท่านั้น
            และบริษัทจะดำเนินมาตรการที่เข้มงวดในการรักษาความมั่นคงปลอดภัย
            ตลอดจนการป้องกันมิให้มีการนำข้อมูลส่วนบุคคลไปใช้โดยมิได้รับอนุญาตจากท่านก่อน
          </p>
        </li>
        <li>
          <div class="font-weight-bold">วัตถุประสงค์</div>
          <p class="mt-4" style="text-indent: 40px">
            ข้าพเจ้ายินยอมให้บริษัททำการจัดเก็บและใช้
            รวมถึงเปิดเผยข้อมูลส่วนบุคคลของข้าพเจ้าเพื่อวัตถุประสงค์ ดังต่อไปนี้
          </p>
          <ol>
            <li>
              เพื่อเสนอขายผลิตภัณฑ์ประกันภัย/ประกันชีวิตประเภทหรือแบบต่างๆ
              และให้บริการอื่นใดของบริษัท
              โดยข้าพเจ้ายินยอมให้บริษัทสามารถเปิดเผยข้อมูลส่วนบุคคลให้กับบริษัท
              เจนเนอราลี่ ประกันชีวิต (ไทยแลนด์) จำกัด (มหาชน) หรือบริษัท
              เจนเนอราลี่ ประกันภัย (ไทยแลนด์) จำกัด (มหาชน) กลุ่มเจนเนอราลี่
              ตัวแทน นายหน้า
              หรือผู้ให้บริการเสนอขายผลิตภัณฑ์ประกันภัยหรือบริการของบริษัท
            </li>
            <li>
              เพื่อรับข้อมูลข่าวสาร การโฆษณาประชาสัมพันธ์ แคมเปญการตลาด
              จากบริษัทและ/หรือผู้ให้บริการเกี่ยวกับการดำเนินการดังกล่าวของบริษัท
            </li>
          </ol>
        </li>
        <li>
          <div class="font-weight-bold">ระยะเวลาในการเก็บ ใช้ และเปิดเผย</div>
          <p class="mt-4">10 ปีนับจากวันที่ได้ให้ความยินยอม</p>
        </li>
        <li>
          <div class="font-weight-bold">
            ประเภทของบุคคลหรือหน่วยงานที่ข้อมูลส่วนบุคคลอาจถูกเปิดเผย
          </div>
          <ol>
            <li>
              บริษัทแม่ บริษัทในเครือ บริษัทในกลุ่มบริษัทเจนเนอราลี่
              และผู้ถือหุ้นของบริษัท
            </li>
            <li>คู่ค้าหรือพันธมิตรทางการค้าและธุรกิจ</li>
            <li>
              ผู้ให้บริการที่เป็นบุคคลภายนอก เช่น
              ผู้ให้บริการเกี่ยวกับเทคโนโลยีสารสนเทศ การตลาด
              การโฆษณาประชาสัมพันธ์ การวิเคราะห์ข้อมูล สถิติ
              การวิจัยและพัฒนาผลิตภัณฑ์ เป็นต้น
            </li>
            <li>
              หน่วยงานกำกับดูแล
              สำนักงานคณะกรรมการกำกับและส่งเสริมการประกอบธุรกิจประกันภัย
            </li>
          </ol>
        </li>
      </ol>
      <p class="mt-4" style="text-indent: 40px">
        หมายเหตุ หากท่านประสงค์จะเพิกถอนความยินยอมตามแบบฟอร์มนี้
        โปรดติดต่อบริษัทโดยใช้ข้อมูลในหัวข้อ “ติดต่อเรา”
        บริษัทพยายามที่จะทำตามคำร้องขอที่ชอบด้วยกฎหมายทั้งหมดภายในหนึ่งเดือน
        และบริษัทจะติดต่อท่าน
        หากบริษัทต้องการข้อมูลเพิ่มเติมเพื่อทำตามคำร้องขอของท่าน
        บางครั้งบริษัทอาจใช้เวลานานมากกว่าหนึ่งเดือน
        เมื่อคำนึงถึงความซับซ้อนและจำนวนคำร้องขอที่บริษัทได้รับ
      </p> -->
    </v-card-text>
  </v-card>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>
